"use strict";

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

var _slicedToArray = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject4() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          border: ", " ", ";\n          border-radius: ", "px;\n          background-color: ", ";\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n    overflow: hidden;\n    color: ", ";\n    margin-bottom: ", "px;\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var react_syntax_highlighter_1 = require("react-syntax-highlighter");

var bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");

var jsx_1 = __importDefault(require("react-syntax-highlighter/dist/esm/languages/prism/jsx"));

var bash_1 = __importDefault(require("react-syntax-highlighter/dist/esm/languages/prism/bash"));

var css_1 = __importDefault(require("react-syntax-highlighter/dist/esm/languages/prism/css"));

var markup_1 = __importDefault(require("react-syntax-highlighter/dist/esm/languages/prism/markup"));

var tsx_1 = __importDefault(require("react-syntax-highlighter/dist/esm/languages/prism/tsx"));

var typescript_1 = __importDefault(require("react-syntax-highlighter/dist/esm/languages/prism/typescript"));

var ActionBar_1 = require("../../layout/ActionBar/ActionBar");

var formatter_1 = __importDefault(require("./formatter"));

var languages_1 = __importDefault(require("./languages"));

var ScrollArea_1 = __importDefault(require("../../layout/ScrollArea/ScrollArea"));

var Pre_1 = __importDefault(require("../Pre/Pre"));

var codeStyle_1 = __importDefault(require("./codeStyle"));

react_syntax_highlighter_1.PrismLight.registerLanguage("jsx", jsx_1["default"]);
react_syntax_highlighter_1.PrismLight.registerLanguage("bash", bash_1["default"]);
react_syntax_highlighter_1.PrismLight.registerLanguage("css", css_1["default"]);
react_syntax_highlighter_1.PrismLight.registerLanguage("html", markup_1["default"]);
react_syntax_highlighter_1.PrismLight.registerLanguage("tsx", tsx_1["default"]);
react_syntax_highlighter_1.PrismLight.registerLanguage("typescript", typescript_1["default"]);
var Wrapper = styled_components_1["default"].div(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      bordered = _ref.bordered;
  return styled_components_1.css(_templateObject2(), bitcoincom_pkg_theme_1.colors.solid.white, theme.spacing.unit * 3, bordered ? styled_components_1.css(_templateObject3(), theme.border.solid["default"], theme.palette.border["default"], theme.border.radius.medium, bitcoincom_pkg_theme_1.colors.solid.comet) : styled_components_1.css(_templateObject4()));
});
var CodeElement = styled_components_1["default"].code({
  flex: 1,
  paddingRight: 0,
  opacity: 1
});
/**
 * Syntax highlighter for code styles extended and styled PrismLight
 *
 * from [React Syntax Highlighter](https://github.com/conorhastings/react-syntax-highlighter)
 */

exports.Code = function (props) {
  var _props$language = props.language,
      language = _props$language === void 0 ? "javascript" : _props$language,
      children = props.children,
      code = props.code,
      _props$useInlineStyle = props.useInlineStyles,
      useInlineStyles = _props$useInlineStyle === void 0 ? true : _props$useInlineStyle,
      _props$copyable = props.copyable,
      copyable = _props$copyable === void 0 ? true : _props$copyable,
      _props$bordered = props.bordered,
      bordered = _props$bordered === void 0 ? true : _props$bordered,
      _props$padded = props.padded,
      padded = _props$padded === void 0 ? false : _props$padded,
      _props$format = props.format,
      format = _props$format === void 0 ? true : _props$format,
      maxHeight = props.maxHeight,
      _props$className = props.className,
      className = _props$className === void 0 ? null : _props$className,
      rest = __rest(props, ["language", "children", "code", "useInlineStyles", "copyable", "bordered", "padded", "format", "maxHeight", "className"]);

  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      copied = _react_1$useState2[0],
      setCopied = _react_1$useState2[1];

  var onClick = function onClick(e) {
    var _a;

    e.preventDefault();
    var tmp = document.createElement("textarea");
    var focus = document.activeElement;
    tmp.value = ((_a = children) === null || _a === void 0 ? void 0 : _a.toString()) || "";
    document.body.appendChild(tmp);
    tmp.select();
    document.execCommand("copy");
    document.body.removeChild(tmp);
    if (focus) focus.focus();
    setCopied(true);
    window.setTimeout(function () {
      return setCopied(false);
    }, 1500);
  };

  return children || code ? react_1["default"].createElement(Wrapper, {
    bordered: bordered,
    padded: padded,
    className: className
  }, react_1["default"].createElement(ScrollArea_1["default"], {
    style: {
      maxHeight: maxHeight
    }
  }, react_1["default"].createElement(react_syntax_highlighter_1.PrismLight, Object.assign({
    padded: padded || bordered,
    language: language,
    useInlineStyles: useInlineStyles,
    PreTag: Pre_1["default"],
    CodeTag: CodeElement,
    style: codeStyle_1["default"]({
      padded: padded
    }),
    customStyle: {
      fontSize: 16
    },
    lineNumberContainerStyle: {
      paddingRight: 16,
      color: bitcoincom_pkg_theme_1.colors.solid.vulcanLightest
    }
  }, rest), format ? formatter_1["default"]((children ? children : code).trim()) : (children ? children : code).trim())), copyable ? react_1["default"].createElement(ActionBar_1.ActionBar, {
    actionItems: [{
      title: copied ? "Copied" : "Copy",
      onClick: onClick
    }]
  }) : null) : null;
};

exports.Code.displayName = "Code";
exports.Code.Languages = languages_1["default"];
exports["default"] = exports.Code;